<template>
  <div>
    <div class="page-main has-bottom">
      <page-title :back="true" @goback="goback" />
      <page-card v-loading="loading" style="margin-bottom:32px">
        <template slot="header">
          Producer Information
        </template>
        <div slot="body">
          <base-info :page-data.sync="pageData" />
          <div class="add-header">
            Well Information
          </div>
          <wellComp
            v-for="(well, index) in wellList"
            :key="'well' + index"
            :page-data="well"
            :well-index="index"
          />
        </div>
      </page-card>
    </div>

    <page-bottom>
      <!-- v-if="pageData.status=='1'" -->
      <template>
        <div class="page-btns">
          <loading-btn label="Reject" @clickHandle="toReject" />
          <loading-btn type="primary" label="Approval" @clickHandle="agree" />
        </div>
      </template>
    </page-bottom>
    <editInformationSuccess
      ref="editInformationSuccess"
      :no-tip="true"
      msg="Approved completed!"
      @close="goback"
    />
    <rejectDialog ref="rejectDialog" @success="reject" @cancel="rejectCancel" />
  </div>
</template>

<script>
/* global web3 */
import { producerDetail, approvalProducerInfo, updateWellStatus } from '@/api/manager.js'
import wellComp from '@/views/wellManage/myWells/wellInfo.vue'
import baseInfo from '@/views/wellManage/myWells/baseInfo.vue'
import editInformationSuccess from '@/views/authentication/editInformationSuccess.vue'
import rejectDialog from './components/rejectDialog.vue'
export default {
  components: {
    wellComp,
    baseInfo,
    editInformationSuccess,
    rejectDialog
  },
  data() {
    return {
      loading: false,
      pageData: {
        accAddress: undefined,
        companyName: undefined,
        wellLicense: undefined
      },
      wellList: [],
      contractParams: []
    }
  },
  computed: {
  },
  created() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.loading = true
      const param = {
        userID: this.$route.query.userID
      }
      producerDetail(param)
        .then(res => {
          const resData = res.result || {}
          const list = this.normalizeWellList(resData.list || [])
          const account = resData.producer.account
          this.contractParams = []
          list.forEach((well) => {
            if (well.sulphur && well.APIGravity) {
              this.contractParams.push({
                account: account,
                location_id: well.location_id,
                location: well.location,
                UWI: well.UWI,
                API: well.APIGravity,
                sulphur: well.sulphur
              })
            }
          })

          this.pageData = resData.producer
          this.wellList = list
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    normalizeWellList(list) {
      return list.flatMap((item) => {
        if (Array.isArray(item.wells) && item.wells.length > 0) {
          return item.wells
        }
        return item.wellID ? [item] : []
      })
    },
    toReject(btn) {
      this.btn = btn
      this.$refs.rejectDialog.open({ pageData: this.pageData })
    },
    rejectCancel() {
      this.btn && this.btn.closeLoad()
    },
    reject(refusalReason) {
      if (this.CheckAccount().res !== '1') {
        this.btn && this.btn.closeLoad()
        return
      }
      this.$confirm('Are you sure to reject the application ?', 'Operation confirmation', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(() => {
        this.approval(3, refusalReason)
      }).catch(e => {
        this.btn && this.btn.closeLoad()
      })
    },
    agree(btn) {
      this.btn = btn
      if (this.CheckAccount().res !== '1') {
        this.btn && this.btn.closeLoad()
        return
      }
      this.$confirm('Are you sure to approve the application ?', 'Operation confirmation', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(() => {
        this.approval(2)
      }).catch(e => {
        this.btn && this.btn.closeLoad()
      })
    },
    approveWell(wellID, status) {
      return new Promise((resolve, reject) => {
        updateWellStatus({
          wellID,
          status
        }).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    async approval(status, refusalReason) {
      if (this.CheckAccount().res !== '1') {
        this.btn && this.btn.closeLoad()
        return
      }
      const param = {
        userID: this.$route.query.userID,
        type: 'mineral',
        status: status,
        refusalReason
      }
      if (status === 2) {
        const httpList = []
        for (let i = 0; i < this.contractParams.length; i++) {
          const { account, location_id, location, UWI, API, sulphur } = this.contractParams[i]
          httpList.push(this.submitContract(account, location_id, location, UWI, API, sulphur))
        }

        Promise.all(httpList).then(resAll => {
          const httpListApproveWell = []
          this.wellList.forEach(well => {
            httpListApproveWell.push(this.approveWell(well.wellID, 1))
          })
          approvalProducerInfo(param).then(res => {
            Promise.all(httpListApproveWell).then(resWell => {
              this.btn && this.btn.closeLoad()
              this.$refs.editInformationSuccess.open()
            }).catch(e => {
              console.log('rrr', e)
              this.btn && this.btn.closeLoad()
            })
          }).catch(e => {
            console.log('wwww', e)
            this.btn && this.btn.closeLoad()
          })
        }).catch(e => {
          console.log('approval', e)
          this.btn && this.btn.closeLoad()
        })
      } else if (status === 3) {
        approvalProducerInfo(param).then(res => {
          this.btn && this.btn.closeLoad()
          this.$refs.editInformationSuccess.open()
        }).catch(() => {
          this.btn && this.btn.closeLoad()
        })
      }
    },
    submitContract(account, location_id, location, UWI, API, sulphur) {
      return new Promise((resolve, reject) => {
        try {
          this.contractGovernance = this.$store.getters.contractMap['contractGovernance'].contract
          this.contractGovernanceAddress = this.$store.getters.contractMap['contractGovernance'].address
          const tx_builder = this.contractGovernance.methods['setProducerData'](
            account, location_id, location, UWI, API, sulphur
          )
          const encoded_tx = tx_builder.encodeABI()
          console.log(account, location_id, location, UWI, API, sulphur)
          web3.eth
            .sendTransaction({
              gas: this.$store.getters.gas,
              from: this.$store.getters.metaMaskObj.account,
              to: this.contractGovernanceAddress,
              value: 0,
              data: encoded_tx
            })
            .then(res => {
              console.log('ok', account, location_id, location, UWI, API, sulphur)
              resolve()
            })
            .catch(error => {
              console.error(error)
              reject(error)
            })
        } catch (e) {
          console.error(e)
          this.$message.error('operation failed')
        }
      })
    },
    goback() {
      this.$router.push('/authentication/approve')
    }
  }
}
</script>
<style scoped lang="scss">
.page-main {
  ::v-deep .page-card .page-card_head {
    border-bottom: none;
  }
  ::v-deep .page-card .page-card_body {
    padding-top: 0;
  }
  .add-header {
    padding: 0.24 rem 0.32 rem;
    border-bottom: 1 px solid #f0f0f0;
    font-size: 0.22rem;
    font-weight: bold;
    margin: 0.24rem 0;
  }
}
</style>
